import { UpdateUserInput } from '@akin-home/amplify';
import { UserModel } from '@akin-home/user';
import { useUpdateUserQuick } from '@akin-home/users/react';
import { useCallback } from 'react';
import { shallow } from 'zustand/shallow';
import { useStateStore } from '../../stores/useStateStore';

export const useCurrentProfile = () =>
  useStateStore(
    (state) => ({ profile: state.current_user as UserModel }),
    shallow
  );

export const useCurrentUser = () =>
  useStateStore((state) => state.current_user as UserModel);

export const useCurrentUserID = () =>
  useStateStore((state) => (state.current_user as UserModel).id);


export const useCurrentUsername = () =>
  useStateStore((state) => (state.current_user as UserModel).username);

export const useUpdateCurrentUser = () => {
  const updateUser = useUpdateUserQuick();
  const id = useCurrentUserID();

  return useCallback(
    (input: Omit<UpdateUserInput, 'id'>) => {
      return updateUser.mutateAsync({ input: { ...input, id } });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [id]
  );
};
